module.exports = __webpack_public_path__ + "static/img/youkoso.f32d30f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/youkoso.png
// module id = 00Bd
// module chunks = 1